const defaultState = {
  isStarted: false,
}

export default {
  namespace: 'app',
  state: Object.assign({}, defaultState),
  reducers: {
    start(state) {
      window.ga('send', 'event', 'Переходы', 'К началу игры', 'publisher')

      return Object.assign({}, state, {
        isStarted: true
      })
    },
    reset() {
      window.ga('send', 'event', 'Переходы', 'Повторное прохождение', 'publisher')

      return Object.assign({}, defaultState)
    }
  },
}



// WEBPACK FOOTER //
// ./src/models/app/index.js